import React, { useEffect } from "react";
//import Hls from "hls.js";
// import ModalWrap from "../modals/ModalWrap";
import "./videoPlayer.scss";

const VideoPlayer = ({ src }) => {
  // const videoRef = useRef(null);

  useEffect(() => {
    // videoRef.current;
    // const video = videoRef.current;
    // if (Hls.isSupported()) {
    //   const hls = new Hls();
    //   hls.loadSource(src);
    //   hls.attachMedia(video);
    // } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
    //   video.src = src;
    // }
  }, [src]);

  return (
    <div className="video-player-wrapper">
      <video
        // ref={videoRef}
        controls
        autoPlay
        src={src}
        controlsList="nodownload noplaybackrate"
        playsInline
        disablePictureInPicture
        style={{ width: "100vw", height: "100vh" }}
        className="video"
      ></video>
    </div>
  );
};

export default VideoPlayer;
